<!--
 * @FileDescription: 角色model（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-06-3（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-06-3（最后更新时间）
 -->
<template>
  <div>
      <a-modal :title="title"  v-model="isShowModel" class="role-model"  @ok="onCofrimForm"  @cancel="onCancel">
          <a-form :form="form"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 16 }"
          >
              <a-form-item label="岗位名称">
                  <a-input placeholder="请输入岗位名称"
                           v-decorator="['roleName', { rules: [{ required: true, message: '请输入角色名称' }] }]" />
              </a-form-item>
              <a-form-item label="岗位描述">
                  <a-textarea placeholder="请输入岗位描述" class="role-desc"
                              v-decorator="['description', { rules: [{ required: false, message: '请输入角色描述' }] }]" ></a-textarea>
              </a-form-item>
          </a-form>
      </a-modal>
      <a-modal :title="title1"  v-model="isShowModel1" class="role-power"  @ok="onCofrimFormPower" @cancel="onCancel">
          <div class="clear-check" @click="clearCheck()">清空已选</div>
         <a-spin  :spinning="$store.state.tabLoding">
                <div class="power-table div-overflow">
                    <div class="power-th" v-for="item in powerObj" :key="item.id">
                        <div class="power-th-text">
                            <div @click="changeOpen(item)"> 
                                <img src="@/assets/image/power-down.png" v-if="item.isOpen"/>
                                <img src="@/assets/image/pown-left.png" v-if="!item.isOpen"/>
                            </div>
                            <a-checkbox @change="onCheckAllChange(item)"
                                        :indeterminate="item.indeterminate"
                                        :checked="item.checkedFlag">
                                {{item.name}}
                            </a-checkbox>
                        </div>
                        <div class="power-td" >
                            <template v-for="(item1,index) in item.children">
                                <div class="power-td-1" :key="item1.id" v-if="index < 1 || item.isOpen">
                                    <div class="power-td-text1">
                                        <a-checkbox @change="onCheckAllChangeTwo(item1,item)"
                                                    :indeterminate="item1.indeterminate"
                                                    :checked="item1.checkedFlag">
                                            {{item1.name}}
                                        </a-checkbox>
                                    </div>
                                    <div class="power-td-tr">
                                        <div class="power-td-dis" v-for="item2 in item1.children" :key="item2.id">
                                            <div class="power-td-text2">
                                                <a-checkbox @change="onCheckChangeThree(item2,item1,item)"
                                                            :indeterminate="item2.indeterminate"
                                                            :checked="item2.checkedFlag">
                                                    {{item2.name}}
                                                </a-checkbox>
                                            </div>
                                            <div class="power-td-dis-tr" v-if="item2.children.length > 0">
                                                <div class="power-td-text3" v-for="item3 in item2.children" :key="item3.id">
                                                    <a-checkbox @change="onCheckChangeFour(item3,item2,item1,item)"
                                                                :indeterminate="item3.indeterminate"
                                                                :checked="item3.checkedFlag">
                                                        {{item3.name}}
                                                    </a-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </a-spin>
      </a-modal>
  </div>
</template>
<script>
import {saveRole,getUpdateRole,getPermissionListId,saveRolePermission} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import model from  '@/components/model'
export default {
    props:{
    },
    data(){
        return{
            title:'新增角色',
            title1:'分配权限',
            form: this.$form.createForm(this),
            isShowModel:false,
            isShowModel1:false,
            powerObj:[],
            addList:[],
            delList:[],
            poweritem:{},
            index:'',
            roleItem:{},
            isLoding:false
        }
    },
    watch: {
    },
    mounted () {

    },
    created () {

    },
    components: {
        model
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        */
        openRole(index,item){
            this.isShowModel = true
            this.index = index
            if(index == 1){
                this.title = '新增角色'
                this.form = this.$form.createForm(this)
            }else if(index == 2){
                this.roleItem = item
                this.title = '编辑角色'
                this.$nextTick(()=>{
                    this.form.setFieldsValue({
                        roleName:item.roleName,
                        description:item.description,
                    })
                })
            }
        },
        openPower(item){
            this.isShowModel1 = true
            this.delList = []
            this.addList = []
            this.powerObj = []
            this.poweritem = item
            this.powerList()
        },
        onCancel(){
            this.isShowModel = false
            this.isShowModel1 = false
        },
        /**
         * @description:角色编辑或新增保存（方法描述）
         */
        onCofrimForm () {
            if(this.index == 1){
                this.form.validateFields((err, values) => {
                    if(!err){
                        saveRole({
                            companyStoreId:this.$store.state.shopId,
                            roleName:values.roleName,
                            description:values.description,
                            companyId:this.$store.state.companyId
                        },{
                            'Content-Type':'application/json'
                        }).then((res)=>{
                            console.log(res)
                            if(res.success){
                                this.isShowModel = false
                                this.$message.success(res.logMessage)
                                this.$emit('updateRoleList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                })
            }else{
                this.form.validateFields((err, values) => {
                    if(!err){
                        getUpdateRole({
                            companyStoreId:this.$store.state.shopId,
                            roleName:values.roleName,
                            description:values.description,
                            id:this.roleItem.id,
                            companyId:this.$store.state.companyId
                        },{
                            'Content-Type':'application/json'
                        }).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$message.success(res.logMessage)
                                this.$emit('updateRoleList')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }
                })
            }
        },
        /**
         * @description:角色分配权限（方法描述）
         */
        onCofrimFormPower(){
            this.addList = []
            this.delList = []
            this.powerObj.forEach((item)=>{
                item.children.forEach((item1)=>{
                    item1.children.forEach((item2)=>{
                        if(item2.isCheck !== item2.checkedFlag){
                            if(item2.checkedFlag){
                                //false=>true
                                this.addList.push(item2.id)
                                !item1.isCheck && this.addList.indexOf(item1.id) == -1 ? this.addList.push(item1.id) :''
                                !item.isCheck && this.addList.indexOf(item.id) == -1 ? this.addList.push(item.id) :''
                            }else{
                                //true=>false
                                this.delList.push(item2.id)
                                !item1.indeterminate && this.delList.indexOf(item1.id) == -1 ? this.delList.push(item1.id) :''
                                !item.indeterminate && this.delList.indexOf(item.id) == -1 ? this.delList.push(item.id) : ''
                            }
                        }
                        item2.children.forEach((item3)=>{
                            if(item3.isCheck !== item3.checkedFlag){
                                if(item3.checkedFlag){
                                    this.addList.push(item3.id)
                                }else{
                                    this.delList.push(item3.id)
                                }
                            }
                        })
                    })
                })
            })
            if(this.addList.length == 0 && this.delList.length == 0){
                this.isShowModel1 =false
                this.$message.success('保存成功')
                return;
            }
            saveRolePermission({
                addList:this.addList,
                delList:this.delList,
                roleId:this.poweritem.id,
                companyStoreId:this.$store.state.shopId,
            },{
                'Content-Type':'application/json'
            }).then((res)=>{
                if(res.success){
                    this.$message.success(res.logMessage)
                    this.isShowModel1 =false
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
        },
        /**
         * @description:获取分配权限的列表（方法描述）
         */
        powerList(){
            this.$store.state.tabLoding = true
            let data = {
                roleId:this.poweritem.id,
                companyStoreId:this.$store.state.shopId,
            }
            data = this.$qs.stringify(data)
            getPermissionListId(data,{}).then((res)=>{
                if(res.success){
                    res.result.forEach((item)=>{
                        item.isCheck = item.checkedFlag
                        item.isOpen = false
                        let j = 0,k= 0
                        item.children.forEach((item1)=>{
                            item1.isCheck = item1.checkedFlag
                            let i = 0
                            item1.children.forEach((item2)=>{
                                item2.isCheck = item2.checkedFlag
                                if(item2.isCheck){
                                    i++;
                                    k++
                                }
                                item2.children.forEach((item3)=>{
                                    item3.isCheck = item3.checkedFlag
                                })
                            })
                            if(i == item1.children.length){
                                item1.checkedFlag = true
                                item1.indeterminate = false
                            }else if(i>0){
                                item1.checkedFlag = false
                                item1.indeterminate = true
                            }else if(i == 0){
                                item1.checkedFlag = false
                                item1.indeterminate = false
                            }
                            if(item1.checkedFlag){
                                j++
                            }
                        })
                        if(j == item.children.length){
                            item.checkedFlag = true
                            item.indeterminate = false
                        }else if(j>0 || k > 0){
                            item.checkedFlag = false
                            item.indeterminate = true
                        }else if(j==0 && k >0){
                            item.checkedFlag = false
                            item.indeterminate = false
                        }

                    })
                    this.powerObj = res.result
                    this.powerObj[0].isOpen = true
                    this.$store.state.tabLoding = false
                }
            })
        },
        //一级全选
        onCheckAllChange(item){
            item.checkedFlag = !item.checkedFlag
            item.checkedFlag  ? item.indeterminate = false :''
            item.children.forEach((ch)=>{
                ch.checkedFlag = item.checkedFlag
                ch.checkedFlag ? ch.indeterminate = false :''
                ch.children.forEach((ch1)=>{
                    ch1.checkedFlag = item.checkedFlag
                    ch1.children.forEach((ch2)=>{
                        ch2.checkedFlag = item.checkedFlag
                    })
                })
            })

        },
        //二级全选
        onCheckAllChangeTwo(item1,item){
            let i = 0
            item1.checkedFlag = !item1.checkedFlag
            item1.checkedFlag ? item1.indeterminate = false : ''
            item1.children.forEach((ch)=>{
                ch.checkedFlag = item1.checkedFlag
                ch.children.forEach((ch1)=>{
                     ch1.checkedFlag = item1.checkedFlag
                })
            })
            item.children.forEach((ch)=>{
                if(ch.checkedFlag){
                    i++
                }
            })
            if(i == item.children.length){
                item.checkedFlag = true
                item.indeterminate = false
            }else if(i>0){
                item.indeterminate = true
                item.checkedFlag = false
            }else if(i==0){
                item.indeterminate = false
                item.checkedFlag = false
            }

        },
        //三级选择
        onCheckChangeThree(item2,item1,item){
            item2.checkedFlag = !item2.checkedFlag
            item2.children.forEach((item3)=>{
                item3.checkedFlag = item2.checkedFlag
            })
            let i = 0,j = 0
            item1.children.forEach((ch)=>{
                if(ch.checkedFlag){
                    j++
                }
            })
            if(j == item1.children.length){
                item1.indeterminate = false
                item1.checkedFlag = true
            }else if(j > 0){
                item1.indeterminate = true
                item1.checkedFlag = false
            }else if(j == 0){
                item1.indeterminate = false
                item1.checkedFlag = false
            }
            item.children.forEach((ch)=>{
                if(ch.checkedFlag){
                    i++
                }
            })
            if(i==item.children.length){
                item.indeterminate = false
                item.checkedFlag = true
            }else if(i>0 || j > 0){
                item.indeterminate = true
                item.checkedFlag = false
            }else if(i==0 && j==0){
                item.indeterminate = false
                item.checkedFlag = false
            }
        },
          //四级选择
        onCheckChangeFour(item3,item2,item1,item){
            item3.checkedFlag = !item3.checkedFlag
        },
        //清空所有已选的分配权限
        clearCheck(){
            this.powerObj.forEach((item)=>{
                item.checkedFlag = false
                item.indeterminate = false
                item.children.forEach((item1)=>{
                    item1.checkedFlag = false
                    item1.indeterminate = false
                    item1.children.forEach((item2)=>{
                        item2.checkedFlag = false
                        item2.indeterminate = false
                        item2.children.forEach((item3)=>{
                            item3.checkedFlag = false
                            item3.indeterminate = false
                        })
                    })
                })
            })
        },
           //展开或关闭
        changeOpen(item){
            item.isOpen = !item.isOpen
        },
    },

}
</script>

<style lang="scss">
    .role-power{
        width: 1400px !important;
        height: 740px !important;
        .ant-modal-body{
            padding: 0 24px;
        }

    }
    .ant-checkbox-indeterminate .ant-checkbox-inner{
        background: var(--co) !important;
    }
    .ant-checkbox-indeterminate .ant-checkbox-inner::after{
        height: 2px !important;
        background-color: #fff !important;
    }
    .role-model{
        width: 680px !important;
        height: 560px !important;
    }
</style>

<style scoped lang="scss">
    .role-desc{
        height: 240px !important;
    }
    .clear-check{
        cursor: pointer;
        text-align: right;
        color: #FD5621;
        font-size: 14px;
        padding-right: 10px;
    }
   .power-table{
        margin: 10px;
        height: 520px;
        overflow-y: scroll;
        .power-th{
            display: flex;
            align-items: center;
            border-top: 1px solid #EEEEEE;
            border-left: 1px solid #EEEEEE;
            &:last-child{
                border-bottom: 1px solid #EEEEEE;
            }
            .power-th-text{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                text-align: center;
                img{
                    padding: 5px;
                    cursor: pointer;
                    margin-right: 10px;
                }
                // &:last-child{
                //     border-bottom: 1px solid #EEEEEE;
                // }
            }
            .power-td{
                display: flex;
                flex-direction: column;
                flex: 1;
                align-items: self-end;
                .power-td-1{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    border-top: 1px solid #EEEEEE;
                    border-left: 1px solid #EEEEEE;
                    &:first-child{
                        border-top: 1px solid #FFFFFF;
                    }
                    .power-td-text1{
                        width: 150px;
                        text-align: center;
                        line-height: 50px;
                    }
                    .power-td-tr{
                        display: flex;
                        flex-direction: column;
                        flex: 1;
                        align-items: self-end;
                        .power-td-dis{
                            display: flex;
                            align-items: center;
                            width: 100%;
                            border-left: 1px solid #EEEEEE;
                            border-right: 1px solid #EEEEEE;
                            border-bottom: 1px solid #eeee;
                            // &:last-child{
                            //     border-bottom: 1px solid #FFFFFF;
                            // }
                            .power-td-text2{
                                width: 200px;
                                height: 50px;
                                line-height: 50px;
                                padding-left: 20px;
                            }
                            .power-td-dis-tr{
                                display: flex;
                                flex-wrap: wrap;
                                padding: 10px 10px;
                                flex: 1;
                                border-left: 1px solid #EEEEEE;
                                border-right: 1px solid #EEEEEE;
                                .power-td-text3{
                                    padding: 2px 5px;
                                    text-align: center;
                                }

                             }
                        }
                    }
                }
            }
        }
    }
</style>
